export default __webpack_public_path__ + "static/media/Planet1.111afa2e.png";